
import {defineComponent, PropType} from "vue";
import {saveAs} from "file-saver";
import filenamify from "filenamify/browser";
import {extension, prepareDownloadFile} from "../../utils/file";
import Analytics from "../../utils/analytics";
import RawResult from "../emoji/RawResult.vue";
import Preview from "../emoji/Preview.vue";
import Button from "../inputs/Button.vue";
import Checkbox from "../inputs/Checkbox.vue";
import Space from "../global/Space.vue";
import Card from "../global/Card.vue";
import Effect from "../icons/Effect.vue";
import Back from "../icons/Back.vue";
import Save from "../icons/Save.vue";
import {NODE_ENV} from "../../utils/env";

export default defineComponent({
  components: {
    RawResult, Preview, Checkbox, Card, Space, Button, Effect, Back, Save,
  },
  props: {
    images: {type: Array as PropType<Blob[][]>, required: true},
    name: {type: String, default: null},
    showTarget: {type: Boolean, required: false},
    emojiName: {type: String, default: null},
    existingEmojis: {type: Array as PropType<string[]>, default: () => []},
    registrationStatus: {type: String as PropType<'loading' | 'success' | 'error' | null>, default: null},
  },
  emits: [
    "toggleShowTarget",
    "registrationStart",
  ],
  data() {
    return {
      previewMode: false,
      rounded: false,
      isDev: NODE_ENV === "development",
    };
  },
  computed: {
    resultImageUrls(): string[][] {
      return this.images.map((row) => row.map((cell) => URL.createObjectURL(cell)));
    },
    totalSize(): number {
      return this.images.reduce((l, r) => (
          l + r.reduce((ll, rr) => ll + rr.size, 0)
      ), 0);
    },
    isEmojiNameDuplicate(): boolean {
      if (!this.emojiName) return false;
      return this.existingEmojis.includes(this.emojiName);
    },
    canReact(): boolean {
      return !!(
        this.name &&
        this.emojiName &&
        !this.isEmojiNameDuplicate &&
        this.registrationStatus !== 'loading'
      );
    },
    buttonText(): string {
      if (this.registrationStatus === 'loading') return '登録中...';
      if (this.isEmojiNameDuplicate) return '名前が重複';
      if (!this.emojiName) return '名前を入力';
      return 'リアクション';
    },
  },
  methods: {
    onDownload(): void {
      const download = prepareDownloadFile(this.images);
      const filename = filenamify(this.name ?? "", {replacement: ""}).normalize() || "megamoji";
      download.then((res) => saveAs(res, `${filename}.${extension(res)}`));
      Analytics.download();
    },
    reaction(): void {
      if (!this.canReact) return;

      console.log("reactionClicked");
      this.$emit('registrationStart');

      if (this.images.length > 0 && this.images[0].length > 0) {
        const blob = this.images[0][0];

        const reader = new FileReader();
        reader.onloadend = () => {
          const base64data = reader.result;
          window.parent.postMessage(JSON.stringify({
            "source": "emoji-gen",
            "emojiName": this.emojiName,
            "binaryData": base64data
          }), "*");
        };
        reader.readAsDataURL(blob);
      }
    },
  },
});
